import "intersection-observer";
import { Promise } from "bluebird";
import "./cleaner";

window.Promise = Promise;
Promise.config({ cancellation: true });

import Vue from "vue";

import CompositionApi from "@vue/composition-api";
Vue.use(CompositionApi);

import App from "./App.vue";
import router from "./router";
import store from "./store/root";
import Auth from "@/auth";
import Analytics from "@/analytics";
import "./icons";
import "./polyfills";

Vue.config.productionTip = false;

Vue.use(Auth);
Vue.use(Analytics);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
